import { Injectable } from "@angular/core";
import { APPLICATIONS_ERROR, MCEnvironmentsService, Store } from "@maslul/common-services";
import { Observable } from "rxjs";

export class GeneralStoreData {
    formState: any;
    errorPageCode!: APPLICATIONS_ERROR;
}
const GENERAL: GeneralStoreData =
{
    formState: {},
    errorPageCode: APPLICATIONS_ERROR.general
}

@Injectable({
    providedIn: 'root',
})
export class GeneralStore extends Store<GeneralStoreData> {

    constructor(protected override environmentsService: MCEnvironmentsService) {
        super('', GENERAL, environmentsService);
    }


    getFormState(): Observable<any> {
        return this.select(s => s.formState);
    }

    setFormState(formState: any) {
        this.updateState('[General Store Service] set formState', { formState })
    }

    getErrorPageCode(): Observable<APPLICATIONS_ERROR> {
        return this.select(s => s.errorPageCode);
    }

    setErrorPageCode(errorPageCode: APPLICATIONS_ERROR) {
        this.updateState('[General Store Service] set errorPageCode', { errorPageCode })
    }
}